import { ThemeProvider, ToastProvider } from '@navegasistemas/dls-navega-rjs'
import { useThemeStore } from '@/store/theme-store'
import App from './App.tsx'

export function Root() {
  const { themeName, setTheme } = useThemeStore()
  return (
    <ThemeProvider theme={themeName} onThemeChange={setTheme}>
      <ToastProvider>
        <App />
      </ToastProvider>
    </ThemeProvider>
  )
}
